import { useMediaQuery } from '@vueuse/core';
import type { ComputedRef } from 'vue';

/**
 * Viewport width (in px) at which the app switches from the desktop layout
 * to the mobile layout. This is Bootstrap's `xxl` breakpoint, i.e. the same
 * width at which the top bar switches to hamburger mode
 * (`toggleable="xxl"` in TopBar.vue). Below this width, the study list
 * renders cards instead of table rows and desktop-only controls (e.g. the
 * column selection button in the sidebar) are hidden.
 */
export const MOBILE_VIEWPORT_BREAKPOINT_PX = 1400;

/**
 * Media query matching all viewports strictly below the mobile breakpoint.
 * The 0.02px offset is the standard way of expressing "below 1400px" in
 * media queries (same convention as Bootstrap's responsive utilities).
 */
export const MOBILE_VIEWPORT_MEDIA_QUERY = `(max-width: ${MOBILE_VIEWPORT_BREAKPOINT_PX - 0.02}px)`;

/**
 * Reactive flag that is `true` while the viewport is narrower than
 * MOBILE_VIEWPORT_BREAKPOINT_PX.
 *
 * @returns computed ref holding the current mobile-viewport state
 */
export const useIsMobileViewport = function (): ComputedRef<boolean> {
  return useMediaQuery(MOBILE_VIEWPORT_MEDIA_QUERY);
};
